import { mutatorAction } from "satcheljs";
import { shiftRequestsPanelStore } from "../";

export default mutatorAction('SET_SHOULD_SCROLL_TO_SELECTED', function setShouldscrollToSelected(shouldScrollToSelected: boolean) {
    shiftRequestsPanelStore().shouldScrollToSelected = shouldScrollToSelected;
});
